<template>
  <div class="time-scale">
    <div
      v-for="(minutes, idx) in marks"
      :key="idx"
      class="time-mark"
      :class="tickType(minutes)"
      :style="{ height: `${getMarkHeight()}px` }"
    >
      <div class="tick"></div>
      <span class="time-label">{{ formatTime(minutes) }}</span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

const SLOT_HEIGHT = 31

export default {
  name: 'TimeScale',
  props: {
    marks: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    cellInterval() {
      return this.user.cell_interval ?? 15
    }
  },
  methods: {
    formatTime(totalMinutes) {
      const h = Math.floor(totalMinutes / 60)
      const m = totalMinutes % 60
      const hh = String(h).padStart(2, '0')
      const mm = String(m).padStart(2, '0')
      return `${hh}:${mm}`
    },
    tickType(totalMinutes) {
      if (totalMinutes % 60 === 0) return 'mark-hour'
      if (totalMinutes % 30 === 0) return 'mark-half'
      return 'mark-quarter'
    },
    getMarkHeight() {
      return SLOT_HEIGHT * (this.cellInterval / 15)
    }
  }
}
</script>

<style scoped>
.time-scale {
  width: 94px;
  box-sizing: border-box;
  padding: 0 4px;
  overflow: hidden;
  font-family: var(--ui-font-family-base);
}

.time-mark {
  position: relative;
  height: 31px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--cal-bg-cell-alt);
}

.time-mark:nth-child(even) {
  background: var(--cal-bg-cell);
}

.time-mark:first-of-type {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

.tick {
  display: none;
}

.time-label {
  position: absolute;
  right: 0;
  left: 0;
  text-align: center;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
  font-feature-settings: "tnum" 1;
}

.mark-hour .time-label {
  font-size: 16px;
  font-weight: 600;
  color: var(--cal-text-primary);
  line-height: 31px;
}

.mark-half .time-label {
  font-size: 13px;
  font-weight: 700;
  color: var(--cal-text-primary);
  line-height: 31px;
}

.mark-quarter .time-label {
  font-size: 11px;
  font-weight: 300;
  color: var(--cal-text-regular);
  line-height: 31px;
}
</style>
